module.exports = __webpack_public_path__ + "eye.svg";